module.exports = __webpack_public_path__ + "img/cart.e4ff1e16.svg";